import type { DataExportScheduleResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetActiveDataExportScheduleSubscription } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetActiveDataExportScheduleDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createSubscriptionHook } from 'src/utils';

type UseGetActiveDataExportScheduleArgs = Record<string, never>;

/**
 * Poll interval for the active-schedule row (COI-772).
 *
 * 30s register-tier bracket, not the 5s detail one: this is a CONFIGURATION row
 * rather than a progress feed. The user's own save already refetches explicitly in
 * `pages/settings/tabs/data-export/Tab.tsx`, so the poll only has to notice
 * out-of-band changes — a schedule superseded or expired by the provisioner.
 */
const POLL_INTERVAL_MS = 30_000;

export const useGetActiveDataExportSchedule = createSubscriptionHook<
  UseGetActiveDataExportScheduleArgs,
  DataExportScheduleResponseRow[],
  GetActiveDataExportScheduleSubscription
>({
  trpcQueryOptions: (trpc) =>
    trpc.frontend.dataExport.getActiveSchedule.queryOptions(),
  trpcRefetchInterval: () => POLL_INTERVAL_MS,
  mapTrpcDataToGraphQL: (data) => ({ data_export_schedule: data }),
  graphqlDocument: GetActiveDataExportScheduleDocument,
});
